import { useUsersAccessData } from "@src/presentation/providers/UsersAccessDataProvider";
import { Pagination } from "@ir/ui";
import { PageFooter } from "@src/presentation/components/Layout/common";
import ErrorBoundary from "@src/presentation/components/common/ErrorBoundary";

export const UsersAccessFooter = () => {
  const { total, page, limit, loading, setPage } = useUsersAccessData();

  const handlePageChange = (nextPage: number) => setPage(nextPage);

  return (
    <ErrorBoundary>
      {total > limit ? (
        <PageFooter>
          <Pagination
            totalItems={total}
            itemsPerPage={limit}
            currentPage={page}
            onPageChange={handlePageChange}
            isDisabled={loading}
          />
        </PageFooter>
      ) : null}
    </ErrorBoundary>
  );
};
